import type { AccountsWalletsTranslations } from "../interfaces/accountsWallets";

export const accountsWalletsTranslations: AccountsWalletsTranslations = {
  header_title: "Contas e carteiras",
  header_subtitle: "Gestão de contas e carteiras associadas à plataforma.",
  header_hint: "Clique em uma conta para ver o detalhe e o histórico de quem copiou os dados.",
  search_placeholder: "Buscar contas...",
  add_account: "Adicionar conta",
  filters_all_currencies: "Todas as moedas",
  accounts_label_singular: "1 conta",
  accounts_label_plural: "{{count}} contas",
  attachments_none: "Sem anexos",
  attachments_one: "1 anexo",
  attachments_many: "{{count}} anexos",
  card_view_button: "Ver",
  placeholder_new_account: "Nova conta",
  show_more: "Mostrar mais contas",
  success_create: "Conta criada corretamente.",
  success_update: "Conta atualizada corretamente.",
  success_delete: "Conta excluída corretamente.",
  error_delete: "Não foi possível excluir a conta.",
  delete_account_modal_title: "Excluir conta",
  delete_account_modal_message: 'Tem certeza de que deseja excluir esta conta "{{name}}"?',
  delete_account_confirm: "Excluir",
  card_delete_aria: "Excluir conta",
  loading_accounts: "Carregando contas...",
  no_match_search: "Nenhuma conta corresponde à busca.",
  try_other_terms: "Tente outros termos ou limpe o buscador.",
  no_accounts_registered: "Não há contas registradas",
  no_accounts_description:
    "Você ainda não tem contas nem carteiras associadas. Quando adicionar uma, ela aparecerá aqui.",
  no_match_currency: "Nenhuma conta corresponde ao filtro de moeda.",
  adjust_currency_filter: "Ajuste o filtro de moeda.",
  searching: "Buscando…",
  modal_add_title: "Adicionar conta",
  modal_edit_title: "Editar conta",
  modal_create_button: "Criar conta",
  modal_update_button: "Atualizar conta",
  modal_cancel: "Cancelar",
  form_payment_bank: "Conta bancária",
  form_payment_crypto: "Carteira cripto",
  form_payment_binance_pay: "Binance Pay",
  form_account_type_savings: "Conta poupança",
  form_account_type_checking: "Conta corrente",
  form_label_country: "País",
  form_select_country: "Selecionar país...",
  form_currency_label: "Moeda",
  form_label_payment_method: "Método de pagamento",
  form_select_generic: "Selecionar...",
  form_label_internal_alias: "Alias interno",
  form_internal_alias_placeholder: "Ex.: Conta principal BRL",
  form_label_bank_name: "Nome do banco",
  form_select_bank: "Selecionar banco...",
  form_label_red: "Rede",
  form_select_red: "Selecionar rede...",
  form_bank_placeholder: "Ex.: Itaú",
  form_label_account_type: "Tipo de conta",
  form_select_account_type: "Selecionar tipo de conta...",
  form_label_account_number: "Número da conta",
  form_account_number_placeholder: "Ex.: 1234567890",
  form_extra_methods_title: "Dados adicionais do método de pagamento",
  form_select_field_placeholder: "Selecionar {{label}}...",
  form_method_option_ahorros: "Poupança",
  form_method_option_corriente: "Corrente",
  form_method_option_cpf: "CPF",
  form_method_option_cnpj: "CNPJ",
  form_method_option_email: "Email",
  form_method_option_telefono: "Telefone",
  form_method_option_llave_aleatoria: "Chave aleatória",
  form_method_option_id_fps: "ID FPS",
  form_method_option_nit: "Nit",
  form_method_option_cc: "Cc",
  form_method_option_ce: "Ce",
  form_method_option_pasaporte: "Passaporte",
  form_method_option_ppt: "Ppt",
  form_method_placeholder_clabe: "18 dígitos",
  form_label_network: "Rede",
  form_select_network: "Selecionar rede...",
  form_label_wallet_address: "Endereço da carteira",
  form_wallet_address_placeholder: "Ex.: 0x71...f92a",
  form_label_notes: "Notas",
  form_notes_placeholder: "Descrição ou uso da conta",
  form_attachments_label: "Anexos",
  form_attachments_upload_edit_label: "Atualizar documentos",
  form_attachments_description: "PDF, PNG, JPG, WebP até 10 MB. Você pode escolher vários arquivos.",
  form_documents_section_title: "Documentos",
  detail_title_fallback: "Detalhe da conta",
  detail_loading: "Carregando detalhe...",
  detail_error_load: "Não foi possível carregar o detalhe da conta.",
  detail_copy_history: "Histórico de cópias",
  detail_loading_generic: "Carregando...",
  detail_total_copies: "Total de cópias",
  detail_last_copy: "Última cópia",
  detail_never: "Nunca",
  detail_user: "Usuário",
  detail_times_copied: "Vezes copiado",
  detail_nobody_copied: "Ninguém copiou os dados desta conta ainda.",
  detail_error_load_history: "Não foi possível carregar o histórico de cópias.",
  detail_edit_button: "Editar",
  detail_copy_bank_info: "Copiar informação bancária",
  detail_copy_info: "Copiar informação",
  detail_close: "Fechar",
  detail_copied_toast: "Informação copiada para a área de transferência",
  detail_error_copy_toast: "Não foi possível copiar a informação",
  detail_error_download_toast:
    "Não foi possível baixar o arquivo. O servidor deve retornar URLs pré-assinadas para os anexos armazenados no S3.",
  detail_copied: "Copiado",
  detail_copy_button_title: "Copiar",
  detail_country: "País",
  detail_notes: "Notas",
  detail_attachments: "Anexos",
  detail_attachments_count: "Anexos ({{count}})",
  detail_file_n: "Arquivo {{n}}",
  detail_download: "Baixar",
  detail_created: "Criado",
  detail_updated: "Atualizado",
  detail_bank_account: "Conta bancária",
  detail_account_type_label: "Tipo de conta",
  detail_crypto_wallet: "Carteira Cripto",
  detail_network_label: "Rede",
  detail_wallet_address_label: "Endereço da carteira",
  detail_user_label: "Usuário",
  detail_clipboard_alias_fallback: "Conta",

  tracking_title: "Acompanhamento de contas",
  tracking_subtitle:
    'Lista de contas e carteiras. Clique em "Ver" para ver o histórico de quem copiou os dados.',
  tracking_search_placeholder: "Buscar por alias...",
  tracking_search_aria: "Buscar contas",
  tracking_button_refresh: "Atualizar",
  tracking_loading: "Carregando contas…",
  tracking_table_showing_one: "Mostrando 1 registro nesta página (Total: {{total}})",
  tracking_table_showing_many: "Mostrando {{count}} registros nesta página (Total: {{total}})",
  tracking_table_show_label: "Mostrar:",
  tracking_table_empty: "Não há registros para exibir.",
  tracking_table_th_alias: "Alias",
  tracking_table_th_currency: "Moeda",
  tracking_table_th_type: "Tipo",
  tracking_table_th_created: "Criado",
  tracking_table_th_actions: "Ações",
  tracking_table_type_wallet: "Carteira",
  tracking_table_type_bank: "Bancária",
  tracking_table_button_view: "Ver",

  tracking_pagination_records: "Registros de {{from}} a {{to}} de {{total}}",
  tracking_pagination_total_pages: "Total de páginas ({{lastPage}})",
  tracking_pagination_first_page: "Primeira página",
  tracking_pagination_prev_page: "Página anterior",
  tracking_pagination_next_page: "Página seguinte",
  tracking_pagination_last_page: "Última página",

  structured_bank: "Banco",
  structured_institution: "Instituição",
  structured_account_number: "Número da conta",
  structured_account_type: "Tipo de conta",
  structured_document_type: "Tipo de documento",
  structured_document_number: "Número do documento",
  structured_llave_bre_b: "Chave Bre-B",
  structured_celular_nequi: "Número celular Nequi",
  structured_pix_key_type: "Tipo de chave Pix",
  structured_pix_key: "Chave Pix",
  structured_clabe: "CLABE (18 dígitos)",
  structured_rut: "RUT",
  structured_email: "Email",
  structured_cci: "Número CCI",
  structured_identity_document: "Documento de identidade",
  structured_celular_yape: "Número celular Yape",
  structured_celular_plin: "Número celular Plin",
  structured_bank_address: "Endereço do banco",
  structured_routing_number: "Routing number",
  structured_swift_bic: "SWIFT / BIC",
  structured_email_phone_zelle: "Email ou número de telefone",
  structured_iban: "IBAN",
  structured_fps_id_type: "Tipo de identificador",
  structured_fps_id: "Identificador FPS",
  structured_chats_code: "Código CHATS",
  structured_alipay_id: "ID Alipay",
  structured_wechat_id: "ID WeChat",
  structured_account_iban: "Número da conta IBAN",
  structured_celular: "Número celular",
  structured_cbu_cvu: "CBU ou CVU",
  structured_cbu: "CBU",
  structured_cvu: "CVU",
  structured_wallet_address: "Endereço da carteira",
  structured_binance_pay_uid: "UID",
  structured_binance_pay_email: "Email",
  structured_label_fallback: "{{key}}",
};
